module.exports = __webpack_public_path__ + "img/negative.850ffc42.svg";